export const OUR_MANAGMENT = [
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Volodymyr_Tkach.webp",
        name: "Volodymyr Tkach",
        text: "CEO & Co-founder",
        link: "https://www.linkedin.com/in/vova-tkach/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Oleh_Roshka.webp",
        name: "Oleh Roshka",
        text: "Co-founder",
        link: "https://www.linkedin.com/in/oleh-roshka/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Khrystyna_Skop.webp",
        name: "Khrystyna Skop",
        text: "Head of Accounting and Finance",
        link: "https://www.linkedin.com/in/khrystyna-skop-a9a83bb8/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Ann_Bayda.webp",
        name: "Ann Bayda",
        text: "Sales Manager",
        link: "https://www.linkedin.com/in/ann-bayda/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Nika_Boeva.webp",
        name: "Nika Boieva",
        text: "HR Generalist",
        link: "https://www.linkedin.com/in/nika-boieva-%F0%9F%87%BA%F0%9F%87%A6-9aa997242/",
    }
]

export const OUR_EXPERTS = [
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Yaroslav_Chykhut.webp",
        name: "Yaroslav Chykhut",
        text: "Senior Software Engineer",
        link: "https://www.linkedin.com/in/yaroslav-chykhut/",
        call: "https://calendly.com/vova_newsoft/yaroslav-chykhut/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Sviatoslav_Skotar.webp",
        name: "Sviatoslav Skotar",
        text: "E-commerce expert/Senior Software Engineer",
        link: "https://www.linkedin.com/in/sviatoslav-skotar-sturss22/",
        call: "https://calendly.com/vova_newsoft/sviatoslav-skotar/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Oleh_Shevchuk.webp",
        name: "Oleh Shevchyk",
        text: "Strong Middle FullStack Developer",
        link: "https://www.linkedin.com/in/oleh-shevchyk-a166341a3/",
        call: "https://calendly.com/vova_newsoft/oleh-shevchyk/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Iryna_Grygorchuk.webp",
        name: "Iryna Grygorchuk",
        text: "Senior/Lead QA Engineer",
        link: "https://www.linkedin.com/in/iryna-grygorchuk-b46ba6145/",
        call: "https://calendly.com/vova_newsoft/iryna-grygorchuk/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Anton_Rozdorozhniuk.webp",
        name: "Anton Rozdorozhniuk",
        text: "Senior Flutter Developer ",
        link: "https://www.linkedin.com/in/anton-rozdorozhniuk-b44969125/",
        call: "https://calendly.com/vova_newsoft/anton-rozdorozhniuk/",
    },
    {
        image: "https://newsoft-ns.com/media/newsoft_people/Artem_Klieinshmidt.webp",
        name: "Artem Klieinshmidt",
        text: "Senior Mobile Developer",
        link: "https://www.linkedin.com/in/artkleinschmidt/",
        call: "https://calendly.com/vova_newsoft/artem-klieinshmidt/",
    },
]
